import TriggerApi from 'app/developer-v3/pages/triggers/TriggerApi';
import TriggerEditor from 'app/developer-v3/pages/triggers/TriggerEditor';
import TriggerInputEditor from 'app/developer-v3/pages/triggers/TriggerInputEditor';
import TriggerInputsList from 'app/developer-v3/pages/triggers/TriggerInputsList';
import TriggerInputsWrapper from 'app/developer-v3/pages/triggers/TriggerInputs';
import TriggerSettings from 'app/developer-v3/pages/triggers/TriggerSettings';
import Triggers from 'app/developer-v3/pages/triggers';
import { SERVICE_TYPE } from 'app/developer-v3/constants';
import { assignParams } from 'app/common/utils/RouterUtils';
import {
  getTriggerUrl,
  isNewServiceField,
  warnIfLeavingUnsavedChanges,
} from 'app/developer-v3/utils';

export default {
  ...assignParams({ serviceType: SERVICE_TYPE.triggers }),
  routes: {
    '.': Triggers,
    ':triggerKey': {
      component: TriggerEditor,
      routes: {
        '.': {
          onEnter({ router, routeTo }) {
            routeTo(`${getTriggerUrl(router.next.params)}/settings`);
          },
        },
        settings: {
          component: TriggerSettings,
        },
        input: {
          component: TriggerInputsWrapper,
          onEnter({ router, routeTo }) {
            if (isNewServiceField(router.next.params.triggerKey)) {
              routeTo(`${getTriggerUrl(router.next.params)}/settings`);
            }
          },
          routes: {
            '.': TriggerInputsList,
            ':inputKey': TriggerInputEditor,
          },
        },
        api: {
          component: TriggerApi,
          onEnter({ router, routeTo }) {
            if (isNewServiceField(router.next.params.triggerKey)) {
              routeTo(`${getTriggerUrl(router.next.params)}/settings`);
            }
          },
          onLeave: warnIfLeavingUnsavedChanges,
        },
      },
    },
  },
};
